import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const preExportRouter: Array<RouteRecordRaw> = [
    {
        path: '/export',
        name: '数据导出',
        component: Layout,
        meta: { title: '数据导出', icon: 'icon-export', alwaysShow: true },
        children: [
            {
                path: 'activity',
                name: '活动数据',
                component: () => import('@/views/export/FestivalData.vue'),
                meta: { title: '活动数据' }
            },
            {
                path: 'order',
                name: '报表',
                component: () => import('@/views/export/OrderData.vue'),
                meta: { title: '报表' }
            },
            {
                path: 'finance',
                name: '账务报表导出',
                component: () => import('@/views/export/FinanceData.vue'),
                meta: { title: '账务报表' }
            },
            {
                path: 'warehouse',
                name: '数仓数据',
                component: () => import('@/views/export/WarehouseData.vue'),
                meta: { title: '数仓数据' }
            },
            {
                path: 'warehouse-list',
                name: '数仓列表',
                component: () => import('@/views/export/WarehouseList.vue'),
                meta: { title: '数仓列表' }
            },
        ]
    }
]

export default preExportRouter